class VideoFrame extends HTMLElement {
  constructor() {
    super();
    this.onPlayClick = this.onPlayClick.bind(this);
  }

  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;

    this.playButtons = this.querySelectorAll('.video-frame__play-button');
    this.playButtons.forEach((button) => {
      button.addEventListener('click', this.onPlayClick);
    });
  }

  disconnectedCallback() {
    this.playButtons?.forEach((button) => {
      button.removeEventListener('click', this.onPlayClick);
    });
  }

  onPlayClick(event) {
    const playButton = event.currentTarget;
    const mediaContainer = playButton.closest('.video-frame__media');
    if (!mediaContainer) return;

    const iframe = mediaContainer.querySelector('iframe');
    const img = mediaContainer.querySelector('img');

    if (img) img.style.display = 'none';
    playButton.style.display = 'none';

    if (iframe) {
      let src = iframe.getAttribute('src') || '';
      if (!/[\?&]autoplay=1/.test(src)) {
        src += src.indexOf('?') === -1 ? '?autoplay=1' : '&autoplay=1';
      }
      iframe.setAttribute('src', src);
    }
  }
}

customElements.define('video-frame', VideoFrame);
